import menu from "./menu";
import widgets from "./widgets";
import dashboard from "./dashboard";
import addIns from "./add_ins";
import users from "./users";
import configuration from "./configuration";
import plugins from "./plugins";
import rights from "./rights";
import ptmTables from "./ptm_tables";
import help from "./help";
import settings from "./settings";
import notifications from "./notifications";
import appInfo from "./app_info";
import gridLayouts from "./grid_layouts";
import roles from "./roles";
import changelogs from "./changelogs";
import mobile from "./mobile";
import appTokens from "./app_tokens";
import boilerplates from "./boilerplates";
import tasks from "./ext";

export default {
    menu,
    widgets,
    dashboard,
    addIns,
    users,
    configuration,
    plugins,
    rights,
    ptmTables,
    help,
    settings,
    notifications,
    appInfo,
    gridLayouts,
    roles,
    changelogs,
    mobile,
    appTokens,
    boilerplates,
    ext: tasks,
};
